import { useQuery } from "@tanstack/react-query";
import { CompanyInterface } from "../../../../models/GeneralModule/Company";
import { CACHE_KEY_COMPANY } from "../../../../utils/constants";
import companyServices from "../../../../services/general/companyServices";

const useCompany = (page: number, pageSize: number) =>
  useQuery<CompanyInterface[], Error>({
    queryKey: [
      CACHE_KEY_COMPANY,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => companyServices.GetAll(page, pageSize),
    initialData: [],
  });

export default useCompany;
